import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa441bfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-history-row" }
const _hoisted_2 = { class: "left-content" }
const _hoisted_3 = { class: "right-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString($props.paymentInfo.type.toString()), 1 /* TEXT */),
      _createElementVNode("span", null, _toDisplayString($props.paymentInfo.createdAt), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", {
        class: _normalizeClass({ cancel: $props.paymentInfo.type === $setup.IPaymentInfoType.CANCELED })
      }, _toDisplayString($setup.getFormattedAmount()), 3 /* TEXT, CLASS */)
    ])
  ]))
}